import { ROUTER_PATH } from "@/src/config/router";
import type { PortfolioRouteNamespace } from "@/src/utils/portfolioRouting";
import {
  portfolioHoldingsPath,
  portfolioImportPath,
  portfolioRootPath,
} from "@/src/utils/portfolioRouting";

export const INVEST_PORTFOLIO_ROOT = `${ROUTER_PATH.INVEST}/portfolio`;

function investLocalePathPrefix(locale: string): string {
  return locale === "en" ? "" : `/${locale}`;
}

export function buildInvestPortfolioRootPath(locale: string): string {
  return portfolioRootPath("invest", investLocalePathPrefix(locale));
}

export function buildInvestPortfolioImportPath(locale: string): string {
  return portfolioImportPath("invest", investLocalePathPrefix(locale));
}

export function buildInvestPortfolioHoldingsPath(
  locale: string,
  portfolioId: string,
): string {
  return portfolioHoldingsPath(
    "invest",
    portfolioId,
    investLocalePathPrefix(locale),
  );
}

export function resolveInvestPortfolioNamespaceFromPathname(
  pathname: string,
): PortfolioRouteNamespace | null {
  const p = pathname || "";
  if (!p.includes("/invest/portfolio")) {
    return null;
  }
  return "invest";
}
